<app-selector
  #selector
  [multiple]="false"
  [type]="type"
  [(ngModel)]="value"
  [disabled]="disabled"
  [placeholder]="placeholder"
  [styles]="styles"
  [displayWithFn]="displayWithFn.bind(this)"
  [optionsFn]="optionsFn.bind(this)"
  [tooltip]="tooltip"
  newItemLabel="Set another location as output"
  (newItemClick)="on_set_another_location_as_output()"
>
</app-selector>